import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Cases from './views/Cases.vue'
import PendingCases from './views/PendingCases.vue'
import Case from './views/Case.vue'
import Cities from './components/Admin/Cities.vue'
import Zones from './components/Admin/Zones.vue'
import Roles from './components/Admin/Role/Roles.vue'
import Entities from './components/Admin/Entities.vue'
import Entity from './components/Admin/Entity.vue'
import EntityZone from './components/Admin/EntityZone.vue'
import PasswordChange from './components/PasswordChange.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/cases',
            name: 'cases',
            component: Cases
        },
        {
            path: '/admin/entities/zones',
            name: 'entityzone',
            component: EntityZone
        },
        {
            path: '/password',
            name: 'password-change',
            component: PasswordChange
        },
        {
            path: '/formats',
            name: 'entity-formats',
            component: () => import("@/views/entity/format/Formats.vue")
        },
        {
            path: '/formats/:id/records',
            name: 'entity-format-records',
            component: () => import("@/views/entity/format/FormatRecords.vue")
        },
        {
            path: '/admin/pending-cases',
            name: 'pending-cases',
            component: PendingCases
        },
        {
            path: '/cases/:id',
            name: 'case',
            component: Case
        },
        {
            path: '/admin/cities',
            name: 'cities',
            component: Cities
        },
        {
            path: '/admin/zones',
            name: 'zones',
            component: Zones
        },
        {
            path: '/admin/roles',
            name: 'roles',
            component: Roles
        },
        {
            path: '/admin/entities',
            name: 'entities',
            component: Entities
        },
        {
            path: '/admin/entities/:id',
            name: 'edit-entity',
            component: Entity
        },
        {
            path: '/admin/habeas',
            name: 'habeas',
            component: () => import('@/components/Admin/Habeas.vue')
        },
        {
            path: '/admin/fields',
            name: 'admin-fields',
            component: () => import('@/views/admin/field/Fields.vue')
        },
        {
            path: '/admin/formats',
            name: 'admin-formats',
            component: () => import('@/views/admin/format/Formats.vue')
        },
        {
            path: '/admin/petitions',
            name: 'admin-petitions',
            component: () => import('@/components/Admin/Petitions.vue')
        },
        {
            path: '/admin/news',
            name: 'admin-news',
            component: () => import('@/components/Admin/News/News.vue')
        },


    ]
})
